$(document).ready(function(){
	new WOW().init();
  
  $('#images_fl').find('.owl-nav').removeClass('disabled');

 
	$('#images_fl').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		nav:true,
		pagination:true,  dots: false,
		navText: ["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 
  
  $('#images_fl').find('.owl-nav').removeClass('disabled');
  $('.owl-carousel').on('changed.owl.carousel', function(event) {
	$(this).find('.owl-nav').removeClass('disabled');
});

	 
  
	  $(window).on('load',function() {
    equalheight('.new_arrivel');
    
  });
  $(window).on('resize',function() {
    equalheight('.new_arrivel');
  });
	
	 
});

 /*----------------FAQ accordion------------------*/

  $(function() {
    var Accordion = function(el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      var links = this.el.find('.article-title');
      links.on('click', {
        el: this.el,
        multiple: this.multiple
      }, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
      var $el = e.data.el;
      $this = $(this),
        $next = $this.next();

      $next.slideToggle();
      $this.parent().toggleClass('open');

      if (!e.data.multiple) {
        $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
      };
    }
    var accordion = new Accordion($('.accordion-container'), false);
  });

 /*----------------FAQ accordion-end-----------------*/
